import React from 'react';

// About Us Page Component for LVLMANIA
const AboutPage = () => {
  return (
    <div className="min-h-screen bg-gray-900 text-gray-100 antialiased py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-6">

        {/* About Us Hero Section */}
        <section className="text-center mb-16 md:mb-24">
          <h1 className="text-5xl md:text-6xl font-extrabold leading-tight mb-6 bg-clip-text text-transparent bg-gradient-to-r from-purple-300 via-indigo-300 to-pink-300 drop-shadow-lg">
            About LVLMANIA
          </h1>
          <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto">
            Your ultimate destination for endless gaming excitement. We are passionate about connecting gamers and providing an unparalleled experience.
          </p>
        </section>

        {/* Our Mission Section */}
        <section className="bg-gray-800 rounded-3xl shadow-xl p-8 md:p-12 mb-16 transform transition duration-300 hover:scale-[1.01] hover:shadow-2xl border border-gray-700">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-8 text-purple-400">Our Mission</h2>
          <p className="text-base md:text-lg text-gray-300 leading-relaxed text-center max-w-4xl mx-auto">
            At LVLMANIA, our mission is to create a vibrant and inclusive gaming ecosystem where players of all skill levels can discover, play, and connect. We strive to offer a diverse library of games, foster a strong community, and continuously innovate to enhance your gaming journey.
          </p>
        </section>

        {/* Our Story Section */}
        <section className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-16">
            <div className="order-2 md:order-1">
                <h2 className="text-3xl md:text-4xl font-bold mb-6 text-indigo-400">Our Story</h2>
                <p className="text-base md:text-lg text-gray-300 leading-relaxed mb-4">
                    LVLMANIA was founded by a team of dedicated gamers who envisioned a platform that goes beyond just playing games. We wanted to build a place where passion for gaming could thrive, friendships could be forged, and new adventures could begin every single day.
                </p>
                <p className="text-base md:text-lg text-gray-300 leading-relaxed">
                    From humble beginnings, we've grown into a thriving community, constantly expanding our game offerings and features based on player feedback. Every step of our journey is fueled by our love for gaming and our commitment to our community.
                </p>
            </div>
            <div className="order-1 md:order-2">
                <img src="https://placehold.co/600x400/4A5568/ffffff?text=Our+Story" alt="Our Story" className="w-full h-auto rounded-2xl shadow-lg border border-gray-700" />
            </div>
        </section>
{/*
        <section className="mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 text-pink-400">What We Offer</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                <div className="bg-gray-800 rounded-2xl shadow-xl p-6 text-center transform transition duration-300 hover:scale-105 hover:shadow-2xl border border-gray-700">
                    <div className="text-5xl mb-4 text-purple-500">🎮</div>
                    <h3 className="text-xl font-bold text-white mb-2">Vast Game Library</h3>
                    <p className="text-gray-400">Access hundreds of games across all genres, from action-packed adventures to mind-bending puzzles.</p>
                </div>
                <div className="bg-gray-800 rounded-2xl shadow-xl p-6 text-center transform transition duration-300 hover:scale-105 hover:shadow-2xl border border-gray-700">
                    <div className="text-5xl mb-4 text-indigo-500">🤝</div>
                    <h3 className="text-xl font-bold text-white mb-2">Thriving Community</h3>
                    <p className="text-gray-400">Connect with fellow gamers, join guilds, participate in forums, and make new friends.</p>
                </div>
                <div className="bg-gray-800 rounded-2xl shadow-xl p-6 text-center transform transition duration-300 hover:scale-105 hover:shadow-2xl border border-gray-700">
                    <div className="text-5xl mb-4 text-pink-500">🏆</div>
                    <h3 className="text-xl font-bold text-white mb-2">Exciting Tournaments</h3>
                    <p className="text-gray-400">Compete in daily, weekly, and monthly tournaments for bragging rights and amazing prizes.</p>
                </div>
            </div>
        </section> */}
        {/* <section className="bg-gray-800 rounded-3xl shadow-xl p-8 md:p-12 mb-16 transform transition duration-300 hover:scale-[1.01] hover:shadow-2xl border border-gray-700">
                  <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-8 text-purple-400">Why Choose LVLMANIA?</h2>
          <ul className="list-none space-y-4 max-w-3xl mx-auto text-lg text-gray-300">
            <li className="flex items-start">
              <span className="text-green-400 mr-3 text-2xl">✓</span>
              <span>A constantly updated library with new and exciting games.</span>
            </li>
            <li className="flex items-start">
              <span className="text-green-400 mr-3 text-2xl">✓</span>
              <span>Dedicated support team available 24/7 to assist you.</span>
            </li>
            <li className="flex items-start">
              <span className="text-green-400 mr-3 text-2xl">✓</span>
              <span>Secure and fair gaming environment for all players.</span>
            </li>
            <li className="flex items-start">
              <span className="text-green-400 mr-3 text-2xl">✓</span>
              <span>Opportunities to earn rewards and exclusive in-game content.</span>
            </li>
          </ul>
        </section> */}

        {/* Email Subscription Section */}
        <section className="text-center">
          <h2 className="text-4xl md:text-5xl font-extrabold text-white mb-6">Stay Updated!</h2>
          <p className="text-lg md:text-xl text-gray-300 mb-10 max-w-3xl mx-auto">
            Want to be the first to know about new games, features, and exclusive events? Leave your email below to get the latest updates from LVLMANIA!
          </p>
          {/* <div className="flex flex-col sm:flex-row justify-center items-center gap-4 max-w-lg mx-auto">
            <input
              type="email"
              placeholder="Enter your email address"
              className="w-full sm:flex-grow p-3 rounded-xl bg-gray-700 text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-purple-500 placeholder-gray-400 transition duration-300"
            />
            <button className="w-full sm:w-auto bg-purple-600 hover:bg-purple-700 text-white font-bold py-3 px-8 rounded-full shadow-lg transition duration-300 transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-purple-500 focus:ring-opacity-50">
              Subscribe for Updates
            </button>
          </div> */}
          <div className="text-center">
                        <p className="text-lg text-gray-300 mb-4">
                            Have feedback or want to connect? Reach out to us at:
                        </p>
                        <a
                            href="mailto:support@lvlmania.com"
                            className="text-purple-400 hover:text-purple-500 font-bold text-lg transition duration-300"
                        >
                            support@lvlmania.com
                        </a>
                    </div>
        </section>

      </div>
    </div>
  );
};

export default AboutPage;
